import { useEffect } from "react";
export default function NitroProvider({ children }) {
  useEffect(() => {
    // Avoid loading twice
    if (window.nitro) return;

    (function (n, i, t, r, o) {
      var a, m;
      n["NitroObject"] = o;
      n[o] =
        n[o] ||
        function () {
          (n[o].q = n[o].q || []).push(arguments);
        };
      n[o].l = 1 * new Date();
      n[o].h = r;
      a = i.createElement(t);
      m = i.getElementsByTagName(t)[0];
      a.async = 1;
      a.src = r;
      m.parentNode.insertBefore(a, m);
    })(window, document, "script", "https://x.nitrocommerce.ai/nitro.js", "nitro");

    window.nitro("configure", "e00bd65c-9b99-4209-a858-644e6bca6720");
  }, []);

  return children;
}
